export default __webpack_public_path__ + "static/media/customer2.0c321332.svg";